<template>
  <form
    v-on:submit.prevent
  >
    <header class="employee-work-time-controls__head">
      <p class="employee-work-time-controls__head__name">{{ name }}</p>
      <div
        v-if="this.description"
        class="employee-work-time-controls__wrapper-desk">
        <span class="employee-work-time-controls__head__text">Начало</span>
        <p class="employee-work-time-controls__head__time">{{ descriptionTitle }}</p>
      </div>
    </header>
    <work-time-counter
      class="employee-work-time-controls__date"
      v-bind:next-action="nextAction"
      v-bind:desctiption="description"
      v-bind:is-assistant="isAssistant"
      v-bind:doctors-to-assist="doctorsToAssist"
      v-bind:doctor-assist="doctorAssist"
      v-on:select-doctor="onInputDoctorAssist"
      v-on:start="onEmployeeStart"
      v-on:stop="onEmployeeStop"
    />
  </form>
</template>

<script>
import WorkTimeCounter from '@/components/WorkTimeCounter.vue';
/**
 * @description Компонент элементов списка сотрудников для управления рабочим временем.
 * @type {Vue}
 */
export default {
  components: { WorkTimeCounter },
  computed: {
    descriptionTitle() {
      if (!this.description) {
        return '';
      }
      const date = new Date(this.description);
      const hours = this.padZero(date.getHours());
      const minutes = this.padZero(date.getMinutes());
      const day = this.padZero(date.getDate());
      const month = this.padZero(date.getMonth() + 1);
      return `${day}.${month} ${hours}:${minutes}`;
    },
  },
  data() {
    return {
      selectedDoctorToAssist: null,
    };
  },
  methods: {
    /**
     * @description Добавить ноль в начало.
     * @param value
     * @returns {string|*}
     */
    padZero(value) {
      return Number(value) < 10 && String(value).length < 2 ? `0${value}` : value;
    },
    /**
     * @description Обработать связывание ассистентов.
     * @returns {void}
     */
    onInputDoctorAssist(doctorId) {
      this.selectedDoctorToAssist = doctorId;
    },
    /**
     * @description Обработать запуск счетчика сотрудника.
     * @returns {void}
     */
    onEmployeeStart(date) {
      this.$emit(
        'employee-counter-start',
        this.employeeId,
        this.selectedDoctorToAssist,
        date,
      );
    },
    /**
     * @description Обработать остановку счетчика сотрудника.
     * @returns {void}
     */
    onEmployeeStop(date) {
      this.$emit(
        'employee-counter-stop',
        this.employeeId,
        date,
      );
    },
  },
  name: 'EmployeeWorkTimeControlsListItem',
  props: {
    doctorAssist: {
      default: () => '',
      type: String || Number,
    },
    doctorsToAssist: {
      default: () => [],
      type: Array,
    },
    isAssistant: {
      default: () => false,
      type: Boolean,
    },
    nextAction: {
      required: true,
      type: String,
    },
    description: {
      required: true,
      type: String,
    },
    employeeId: {
      required: true,
      type: Number,
    },
    name: {
      required: true,
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
@use "@/scss/buttons";
.v-text-field {
  padding: 0;
  margin: 0;
}
.employee-work-time-controls {
  &-list {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    &__item {
      display: grid;
      grid-template-columns: 1fr 1fr;
      align-items: center;
      grid-gap: 20px;
    }
  }
  &__head {
    display: grid;
    row-gap: 17px;
    align-self: start;
    font-size: 1.125rem;
    &__name {
      overflow: hidden;
      font-weight: 500;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    &__text {
      display: inline-block;
      margin-bottom: 6px;
      font-size: 12px;
      line-height: 16px;
      color: #90a0b7;
    }
    &__time {
      font-size: 14px;
    }
  }
  &__wrapper-input {
    display: grid;
    gap: 13px;
  }
  &__date {
    display: grid !important;
    grid-template-columns: 1fr auto;
    column-gap: 65px !important;
    padding: 0;
  }
  &__start {
    @include buttons.btn-blue(65px, 32px, 14px);
  }
  &__stop {
    @include buttons.btn-transparent(65px, 32px, 14px);
  }
}

@media screen and (max-width: 600px)  {
  .employee-work-time-controls {
    &__head {
      grid-column: 1/-1;
      row-gap: 5px;
    }
    &__date {
      grid-column: 1/-1;
    }
  }
}
</style>
